import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { CONTACT_EMAIL, COMPANY, NAV_LINKS } from "@/config/site";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-coacher-navy-deep text-white">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 py-14 sm:py-20">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img src="/assets/logo.png" alt="CoachER crest" className="h-10 w-10 rounded-lg" />
            <span className="font-display text-2xl font-semibold uppercase tracking-wide">CoachER</span>
          </div>
          <p className="mt-4 text-xs font-semibold uppercase tracking-[0.25em] text-white/60">
            Your Digital Dugout AI Assistant
          </p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="footer-email-link"
            className="mt-6 inline-flex items-center gap-2 text-sm text-white/80 transition-colors hover:text-white"
          >
            <Mail size={16} /> {CONTACT_EMAIL}
          </a>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/50">Pages</p>
          <ul className="mt-4 space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-${l.testId}`} className="text-sm text-white/75 transition-colors hover:text-white">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/50">Legal</p>
          <ul className="mt-4 space-y-2.5">
            <li>
              <Link to="/privacy" data-testid="footer-privacy-link" className="text-sm text-white/75 transition-colors hover:text-white">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms" data-testid="footer-terms-link" className="text-sm text-white/75 transition-colors hover:text-white">
                Terms of Service
              </Link>
            </li>
          </ul>
          <p className="mt-8 text-xs leading-relaxed text-white/50">
            Developed by{" "}
            <a
              href={COMPANY.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-company-link"
              className="text-white/75 underline decoration-coacher-red underline-offset-4 transition-colors hover:text-white"
            >
              {COMPANY.name}
            </a>{" "}
            · {COMPANY.location}
          </p>
        </div>
      </div>

      <div className="mt-14 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-xs text-white/50">© 2026 CoachER · {COMPANY.name}. All rights reserved.</p>
        <p className="text-xs uppercase tracking-[0.2em] text-white/40">Built from the dugout</p>
      </div>
    </div>
  </footer>
);

export default Footer;
